var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5363 5C19.1788 4.6425 18.6013 4.6425 18.2438 5L8.32876 14.9058L4.56063 11.1376C4.20313 10.7801 3.62563 10.7801 3.26812 11.1376C2.91062 11.4951 2.91062 12.0726 3.26812 12.4301L7.62166 16.7836C8.01218 17.1742 8.64535 17.1742 9.03587 16.7837L19.5363 6.28333C19.8846 5.935 19.8846 5.34833 19.5363 5Z",
    fill: "#04B7EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/CheckIcon.849a10dad68cd61ae867ae782a4307f4.svg";
export { ForwardRef as ReactComponent };